import type { StoryNode } from '@/engine/types'

// 序章先让玩家通过具体对话认识人，再在组织功能开放时做第一次重大路线选择。
export const prologueNodes = [
  {
    id: 'p00-opening',
    chapter: 'prologue',
    actLabel: '序章 · 开服前夜',
    date: '2026-07-16',
    title: '23:47',
    location: '房间',
    mode: 'interlude',
    speaker: 'narrator',
    text: '电脑刚关掉，手机又亮了。\n\n那个陪你玩过老区的人发来一条消息：“在吗？4945明晚开，要不要一起？”',
    background: 'invitation',
    music: 'duskLogin',
    historical: 'adapted',
    onEnter: [{ type: 'unlockCg', id: 'cg00-invitation' }],
    next: 'p01-mentor-call',
  },
  {
    id: 'p01-mentor-call',
    chapter: 'prologue',
    actLabel: '序章 · 开服前夜',
    date: '2026-07-16',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '暑假没事干，正好几个人都说要来。这次不乱玩了，开服就冲榜，先把一组占住。祈福带队，奶瓶也来。你来不来？',
    background: 'invitation',
    music: 'duskLogin',
    sound: 'message',
    historical: 'fictional',
    choices: [
      {
        id: 'ask-growth',
        label: '“老区没玩好，这次新区我要认真地玩一下。”',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'power', value: 1 },
          { type: 'relationship', character: 'mentor', key: 'trust', value: 1 },
          { type: 'flag', key: 'askedGrowthFirst' },
          { type: 'variable', key: 's1OpeningMotive', value: 'serious' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'p01a-growth-reply',
      },
      {
        // 保留既有 choice id 与 flag，确保旧存档和统计合同仍能识别这条选择。
        id: 'just-login',
        label: '“开新区我也要来，老区太无聊了。”',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'skill', value: 1 },
          { type: 'flag', key: 'jumpedInBlind' },
          { type: 'variable', key: 's1OpeningMotive', value: 'together' },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p01c-login-reply',
      },
      {
        id: 'ask-organizations',
        label: '“首领叫祈福吗？他和你关系怎么样？你们都是老区来的吗？”',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'mentor', key: 'trust', value: 1 },
          { type: 'flag', key: 'askedOrganizationsFirst' },
          { type: 'variable', key: 's1OpeningMotive', value: 'curious' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'p01b-organization-reply',
      },
    ],
  },
  {
    id: 'p01a-growth-reply',
    chapter: 'prologue', actLabel: '序章 · 开服前夜', date: '2026-07-16',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '好，这次我们一起冲击本服排行榜，冲个一组。开服别迟到啊。',
    background: 'invitation', music: 'duskLogin', historical: 'fictional', next: 'p02-server-open',
  },
  {
    id: 'p01b-organization-reply',
    chapter: 'prologue', actLabel: '序章 · 开服前夜', date: '2026-07-16',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '他是我老区的兄弟，这次正好暑假，就一起开区了。人还可以，人不错，当首领没啥问题。不过他玩不了多长时间，等4999区开服就走了。',
    background: 'invitation', music: 'duskLogin', historical: 'fictional', next: 'p02-server-open',
  },
  {
    id: 'p01c-login-reply',
    chapter: 'prologue', actLabel: '序章 · 开服前夜', date: '2026-07-16',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '好，我们一起开新区，正好缺人呢。你别又玩两天就跑。',
    background: 'invitation', music: 'duskLogin', historical: 'fictional', next: 'p02-server-open',
  },
  {
    id: 'p02-server-open',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    title: '4945区开放',
    location: '游戏客户端',
    mode: 'system',
    speaker: 'system',
    text: '九点零三分，你挤进4945区。老朋友的队伍邀请已经亮起。队伍成员：祈福、顶级奶瓶、老朋友、你。',
    background: 'login',
    sound: 'notice',
    historical: 'confirmed',
    next: 'p02a-online',
  },
  {
    id: 'p02a-online',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '人齐了就开。先跟任务，十级以前别掉队。',
    background: 'login',
    sound: 'message',
    historical: 'fictional',
    next: 'p02b-first-fight',
  },
  {
    id: 'p02b-first-fight',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    title: '开服第一晚',
    location: '开服队伍',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '先别强化那个蓝装，过两级就换了。……你已经全点了？行，当我没问。今晚剩下的任务怎么清？',
    background: 'login',
    historical: 'fictional',
    choices: [
      {
        id: 'follow-tutorial-arrow',
        label: '“你先别下，带我把剩下的任务清完。”',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'power', value: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'p02b-grind-reply',
      },
      {
        id: 'try-movement-first',
        label: '“我不乱点了，你告诉我先升哪个最划算。”',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'skill', value: 1 },
          { type: 'relationship', character: 'mentor', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'p02b-guide-reply',
      },
    ],
  },
  {
    id: 'p02b-grind-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第一天', date: '2026-07-17',
    location: '开服队伍', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '行，我带到体力清空。你跟紧点，别又站在任务门口整理背包。',
    background: 'login', historical: 'fictional', next: 'p03-first-red-dots',
  },
  {
    id: 'p02b-guide-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第一天', date: '2026-07-17',
    location: '开服队伍', mode: 'chat', speaker: 'bottle', portrait: 'bottle',
    text: '先升武器，再补能直接开技能的部位。蓝装别追满，开服前两天最贵的是走错一步以后还继续点。',
    background: 'login', historical: 'fictional', next: 'p03-first-red-dots',
  },
  {
    id: 'p03-first-red-dots',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '教程过了？先别乱点。右上角那个限时礼包，关掉以后还会再弹三次。',
    background: 'login',
    sound: 'message',
    historical: 'fictional',
    choices: [
      {
        id: 'clear-tutorial',
        label: '“我先把教程清完，你把该做的发我。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'mentor', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'p03a-tutorial-reply',
      },
      {
        id: 'watch-world-chat',
        label: '“世界频道已经99+了，这区这么热闹？”',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'p03b-world-reply',
      },
    ],
  },
  {
    id: 'p03a-tutorial-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第一天', date: '2026-07-17',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '行。主线、装备、决斗场。组织二十级开，别急着答应谁。',
    background: 'login', historical: 'fictional', next: 'p04-budget',
  },
  {
    id: 'p03b-world-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第一天', date: '2026-07-17',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '新区第一天，人人都像能玩三年。先记名字，别急着信招募文案。',
    background: 'login', historical: 'fictional', next: 'p04-budget',
  },
  {
    id: 'p04-budget',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    title: '五十块',
    location: '限时礼包',
    mode: 'novel',
    speaker: 'narrator',
    text: '礼包第三次弹出来时，你终于看清价格。六块能让开局轻松一点；十八块够准备一份组织资源；右上角的叉，一分钱也不要。',
    background: 'login',
    historical: 'adapted',
    choices: [
      {
        id: 'save-money',
        label: '关掉页面：“先不花。”',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'skill', value: 1 },
          { type: 'flag', key: 'budgetSaved' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p04a-budget-saved',
      },
      {
        id: 'small-pass',
        label: '买下六元新手包',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'money', value: -6 },
          { type: 'stat', key: 'power', value: 2 },
          { type: 'flag', key: 'boughtStarterPack' },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'p04b-starter-pack-opened',
      },
      {
        id: 'social-fund',
        label: '拿出十八元，先备一份组织资源',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'money', value: -18 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'flag', key: 'preparedOrganizationFund' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'p04c-organization-fund-ready',
      },
    ],
  },
  {
    id: 'p04a-budget-saved',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    location: '游戏客户端',
    mode: 'novel',
    speaker: 'narrator',
    text: '你按下右上角的叉，五十块一分没动。礼包图标缩成一个红点，像是在提醒你：它还会回来。',
    background: 'login',
    historical: 'fictional',
    next: 'p05-first-day',
  },
  {
    id: 'p04b-starter-pack-opened',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    location: '游戏客户端',
    mode: 'novel',
    speaker: 'narrator',
    text: '支付成功的提示只亮了一秒。背包里多出一排材料，原本卡住的装备按钮终于肯继续往上跳。',
    background: 'login',
    historical: 'fictional',
    next: 'p05-first-day',
  },
  {
    id: 'p04c-organization-fund-ready',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    location: '游戏客户端',
    mode: 'novel',
    speaker: 'narrator',
    text: '你没买面板礼包，而是把十八块划进“组织备用”。现在它还换不来战力，只换来备忘录里第一行没删掉的计划。',
    background: 'login',
    historical: 'fictional',
    next: 'p05-first-day',
  },
  {
    id: 'p05-first-day',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    title: '第一个空档',
    location: '游戏客户端',
    mode: 'system',
    speaker: 'system',
    text: '主线暂时卡住。祈福的组队邀请、决斗场入口和99+的世界频道同时亮着，你只够先点开一个。',
    background: 'login',
    historical: 'adapted',
    choices: [
      {
        id: 'focus-power',
        label: '点开祈福发来的组队邀请',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'power', value: 3 },
          { type: 'stat', key: 'level', value: 8 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'flag', key: 'powerFocused' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'p06-early-one',
      },
      {
        id: 'focus-skill',
        label: '先去决斗场打一把',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'skill', value: 3 },
          { type: 'stat', key: 'level', value: 7 },
          { type: 'flag', key: 'skillFocused' },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p05b-first-duel',
      },
      {
        id: 'focus-social',
        label: '在世界频道回一句“新人，求带”',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'stat', key: 'level', value: 7 },
          { type: 'flag', key: 'socialFocused' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 1 },
        ],
        next: 'p05c-first-world-reply',
      },
    ],
  },
  {
    id: 'p05b-first-duel',
    chapter: 'prologue', actLabel: '第一章 · 新区第一天', date: '2026-07-17',
    title: '第一局', location: '决斗场', mode: 'novel', speaker: 'narrator',
    text: '你在开局二十秒交掉替身，又在最后十秒把对方逼到墙角。失败两个字弹出来时，你已经点了再来一局。',
    background: 'login', historical: 'fictional', next: 'p06c-next-evening',
  },
  {
    id: 'p05c-first-world-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第一天', date: '2026-07-17',
    location: '4945 · 世界频道', mode: 'chat', speaker: 'crowd',
    text: '“新人先升级。”“来江南。”“抚梅观清雪收活人。”“别信上面那几个，来天上白玉京。”\n你的那句“求带”很快被顶出了屏幕。',
    background: 'worldChat', music: 'groupChat', historical: 'adapted', next: 'p06c-next-evening',
  },
  {
    id: 'p06-early-one',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-17',
    location: '祈福',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '战力跟得上。群雄逐鹿先给你一个学员位，今天别掉队。明天我再看名单。',
    background: 'organization',
    music: 'groupChat',
    historical: 'fictional',
    choices: [
      {
        id: 'accept-trial',
        label: '“行，一天后你看结果。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'affinity', value: 1 },
          { type: 'flag', key: 'joinedGroupOneTrial' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'p06b-one-trial-result',
      },
      {
        id: 'decline-trial',
        label: '“谢谢，我想先自己看看。”',
        tone: 'bold',
        effects: [
          { type: 'relationship', character: 'qifu', key: 'affinity', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'flag', key: 'declinedGroupOneTrial' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p06c-next-evening',
      },
    ],
  },
  {
    id: 'p06b-one-trial-result',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第一天',
    date: '2026-07-18',
    location: '群雄逐鹿 · 成员列表',
    mode: 'system',
    speaker: 'system',
    text: '榜单刷新：你当前排在第三十七名。群雄逐鹿的学员位已经换了名字，昨晚的候补进入成员栏。',
    background: 'organization',
    sound: 'notice',
    historical: 'fictional',
    onEnter: [
      { type: 'flag', key: 'kickedFromGroupOne' },
      { type: 'stat', key: 'reputation', value: -1 },
    ],
    next: 'p06b-mentor-kick',
  },
  {
    id: 'p06b-mentor-kick',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第二天',
    date: '2026-07-18',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你的战力太低了，一组要排行榜前三十的。你得去后面的组织提一下战力，再回来吧。',
    background: 'nightMessage',
    sound: 'message',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'variable', key: 's1OpeningMotive', operator: 'eq', value: 'together' }, next: 'p06b-together-echo' },
        { when: { type: 'variable', key: 's1OpeningMotive', operator: 'eq', value: 'curious' }, next: 'p06b-curious-echo' },
      ],
      fallback: 'p06c-next-evening',
    },
  },
  {
    id: 'p06b-together-echo',
    chapter: 'prologue', actLabel: '第一章 · 新区第二天', date: '2026-07-18',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '本来说好一起开新区，结果先把你一个人留外面了。这次是我没安排好。我给你找个有人带的地方，你别因为这个又不玩了。',
    background: 'nightMessage', historical: 'fictional', next: 'p06c-next-evening',
  },
  {
    id: 'p06b-curious-echo',
    chapter: 'prologue', actLabel: '第一章 · 新区第二天', date: '2026-07-18',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '你之前问祈福能玩多久——他说等4999区开服就走，但现在一组的名单还是他定。先去后面的组织把战力提上来，别把这次换人当成针对你。',
    background: 'nightMessage', historical: 'fictional', next: 'p06c-next-evening',
  },
  {
    id: 'p06c-next-evening',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第二天',
    date: '2026-07-18',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你可算上了。组织功能还差几级，我的任务车缺一个人。先说好，掉线的话我不停车。',
    background: 'nightMessage',
    sound: 'message',
    historical: 'fictional',
    next: 'p06d-level-sprint',
  },
  {
    id: 'p06d-level-sprint',
    chapter: 'prologue',
    actLabel: '第一章 · 新区第二天',
    date: '2026-07-18',
    title: '升到20级以前',
    location: '任务地图',
    mode: 'system',
    speaker: 'system',
    text: '体力还够跑一轮任务。老朋友的队伍邀请已经亮起，地图另一边也还压着几条没清的支线。',
    background: 'login',
    historical: 'fictional',
    choices: [
      {
        id: 'ride-with-mentor',
        label: '进老朋友的队，把剩下的体力一次清完',
        tone: 'warm',
        effects: [
          { type: 'stat', key: 'power', value: 1 },
          { type: 'stat', key: 'level', value: 8 },
          { type: 'relationship', character: 'mentor', key: 'trust', value: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'p06d-mentor-reply',
      },
      {
        id: 'clear-side-quests-alone',
        label: '关掉语音，自己按地图把支线扫干净',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'skill', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'stat', key: 'level', value: 8 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p06d-solo-reply',
      },
    ],
  },
  {
    id: 'p06d-mentor-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第二天', date: '2026-07-18',
    location: '任务队伍', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '进队。先清经验高的，最后十点体力我帮你卡着。今天别整理背包了，真的没人抢你的蓝装。',
    background: 'login', historical: 'fictional', next: 'p07-recruitment-feed',
  },
  {
    id: 'p06d-solo-reply',
    chapter: 'prologue', actLabel: '第一章 · 新区第二天', date: '2026-07-18',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '行，你自己清。我把容易漏的三条支线发你，做完报一下等级，差一点我再拉你。',
    background: 'nightMessage', historical: 'fictional', next: 'p07-recruitment-feed',
  },
  {
    id: 'p07-recruitment-feed',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    location: '4945 · 世界频道',
    mode: 'chat',
    speaker: 'crowd',
    text: '中午十二点，四条招募轮流刷过屏幕。\n“江南晚上八点带日常，缺一。”“抚梅观清雪收长期在线。”“天上白玉京奖励规则群里可看。”“未闻花名今天团本还差人。”',
    background: 'recruitment',
    music: 'groupChat',
    historical: 'adapted',
    next: 'p07a-four-friends',
  },
  {
    id: 'p07a-four-friends',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你不是还没定组织吗？我先把你推给夏娜了。她那边今晚缺人，至少有人带任务。其他几个你也自己聊，别只看招募词。',
    background: 'recruitment',
    sound: 'message',
    historical: 'fictional',
    next: 'p08-shana-invite',
  },
  {
    id: 'p08-shana-invite',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '夏娜', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '老朋友说你这两天一直在线。江南今晚八点带日常，还缺一个位置。你要来就先按普通成员进，打完再说。',
    background: 'recruitment', historical: 'fictional',
    // Candidate introductions leave the phone for one full-size VN portrait, then return to chat for the reply.
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'push-in', atmosphere: 'messages',
      sprites: [{ character: 'shana', expression: 'determined', pose: 'phone', position: 'right', scale: 1.04 }],
    },
    choices: [
      {
        id: 'shana-carry', label: '“一组那边我可能还会回，但这几天的活动我会正常打。”', tone: 'warm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'relationship', character: 'shana', key: 'affinity', value: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'p08-shana-carry-reply',
      },
      {
        id: 'shana-list', label: '“我先看看今天谁带任务、晚上几点集合。”', tone: 'calm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p08-shana-list-reply',
      },
    ],
  },
  {
    id: 'p08-shana-carry-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '夏娜', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '可以，想回去就提前说。今晚先把奖励领了，八点前在群里回个到。',
    background: 'recruitment', historical: 'fictional', next: 'p08-heartbeat-invite',
  },
  {
    id: 'p08-shana-list-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '夏娜', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '八点我带，骚鸡补位。名单我发你，来不了提前说一声就行。',
    background: 'recruitment', historical: 'fictional', next: 'p08-heartbeat-invite',
  },
  {
    id: 'p08-heartbeat-invite',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '心跳成瘾', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '我这边晚上八点半开车，现在缺一个长期上线的。先说清楚，刚进来没有高层，愿意做事再慢慢加。',
    background: 'recruitment', historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'drift-right', atmosphere: 'messages',
      sprites: [{ character: 'heartbeat', expression: 'smile', pose: 'phone', position: 'left', scale: 1.03 }],
    },
    choices: [
      {
        id: 'heartbeat-work-first', label: '“先把我排普通成员，今晚缺人我补。”', tone: 'warm',
        effects: [
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'relationship', character: 'heartbeat', key: 'affinity', value: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'p08-heartbeat-work-reply',
      },
      {
        id: 'heartbeat-no-promises', label: '“我可能还在看别的组，先不用给我留位置。”', tone: 'calm',
        effects: [
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'p08-heartbeat-rules-reply',
      },
    ],
  },
  {
    id: 'p08-heartbeat-work-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '心跳成瘾', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '行，那我先把你放今晚名单。八点二十五进队，迟到我就先拉别人。',
    background: 'recruitment', historical: 'fictional', next: 'p08-yanqiu-invite',
  },
  {
    id: 'p08-heartbeat-rules-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '心跳成瘾', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '没事，你看好再说。我把群号发你，今晚想来可以临时补位，不算你答应入组。',
    background: 'recruitment', historical: 'fictional', next: 'p08-yanqiu-invite',
  },
  {
    id: 'p08-yanqiu-invite',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '砚秋水', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '我看过你榜单，战力不算高，但这两天都在线。天上白玉京缺稳定出勤，奖励和请假规则都在群公告，你先看。',
    background: 'recruitment', historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'drift-left', atmosphere: 'paper',
      sprites: [{ character: 'yanqiu', expression: 'concerned', pose: 'thinking', position: 'right', scale: 1.02 }],
    },
    choices: [
      {
        id: 'yanqiu-public-rules', label: '“公告能直接看就行，我不想拿了奖励才知道怎么算。”', tone: 'calm',
        effects: [
          { type: 'relationship', character: 'yanqiu', key: 'trust', value: 1 },
          { type: 'relationship', character: 'yanqiu', key: 'affinity', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'p08-yanqiu-public-reply',
      },
      {
        id: 'yanqiu-exceptions', label: '“我上线不一定准时，迟到怎么处理也写了吗？”', tone: 'warm',
        effects: [
          { type: 'relationship', character: 'yanqiu', key: 'trust', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p08-yanqiu-exception-reply',
      },
    ],
  },
  {
    id: 'p08-yanqiu-public-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '砚秋水', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '能看。谁拿了、为什么拿、下一件轮到谁，都会留在同一张表里。',
    background: 'recruitment', historical: 'fictional', next: 'p08-wenxian-invite',
  },
  {
    id: 'p08-yanqiu-exception-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '砚秋水', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '提前说就记请假；临时掉线也能补说明。连续两次不说才会从活动名单往后排。',
    background: 'recruitment', historical: 'fictional', next: 'p08-wenxian-invite',
  },
  {
    id: 'p08-wenxian-invite',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '温陷', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '未闻花名今天团本差一个人。我们不冲第一，晚上有人就一起打，忙的话在群里说一声。你要不要先来一趟？',
    background: 'recruitment', historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'push-in', atmosphere: 'petals',
      sprites: [{ character: 'wenxian', expression: 'soft', pose: 'thinking', position: 'left', scale: 1.02 }],
    },
    choices: [
      {
        id: 'wenxian-stay', label: '“可以，我今晚先跟你们打一趟。”', tone: 'warm',
        effects: [
          { type: 'relationship', character: 'wenxian', key: 'trust', value: 1 },
          { type: 'relationship', character: 'wenxian', key: 'affinity', value: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 2 },
        ],
        next: 'p08-wenxian-stay-reply',
      },
      {
        id: 'wenxian-ask-plan', label: '“要是人没齐，你们一般怎么办？”', tone: 'calm',
        effects: [
          { type: 'relationship', character: 'wenxian', key: 'trust', value: 1 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p08-wenxian-plan-reply',
      },
    ],
  },
  {
    id: 'p08-wenxian-stay-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '温陷', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '好，我给你留到八点四十。人齐就开，没齐我们再喊，不会让你一直等。',
    background: 'recruitment', historical: 'fictional', next: 'p08-second-shana',
  },
  {
    id: 'p08-wenxian-plan-reply',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '温陷', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '先在群里喊，再各自问熟人。真凑不齐就改打小本，别让五个人陪着一直等。',
    background: 'recruitment', historical: 'fictional', next: 'p08-second-shana',
  },
  {
    id: 'p08-second-shana',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '夏娜', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '今晚名单发你了，八点集合。你的位置先留着，七点半还没回我就换候补。',
    background: 'recruitment', historical: 'fictional', next: 'p08-second-heartbeat',
  },
  {
    id: 'p08-second-heartbeat',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '心跳成瘾', mode: 'chat', speaker: 'heartbeat', portrait: 'heartbeat',
    text: '八点半那车还缺一。你要是来就回个1，不来不用解释，我继续喊。',
    background: 'recruitment', historical: 'fictional', next: 'p08-second-yanqiu',
  },
  {
    id: 'p08-second-yanqiu',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '砚秋水', mode: 'chat', speaker: 'yanqiu', portrait: 'yanqiu',
    text: '这是奖励表和今晚名单。你不用现在答应，先看看我们实际是不是按这个发。',
    background: 'recruitment', historical: 'fictional', next: 'p08-second-wenxian',
  },
  {
    id: 'p08-second-wenxian',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '温陷', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '我们人齐了，但有人九点得走。你想来的话我把后半程位置留给你，不来我就继续世界喊。',
    background: 'recruitment', historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'variable', key: 's1OpeningMotive', operator: 'eq', value: 'serious' }, next: 'p08-motive-serious' },
        { when: { type: 'variable', key: 's1OpeningMotive', operator: 'eq', value: 'together' }, next: 'p08-motive-together' },
        { when: { type: 'variable', key: 's1OpeningMotive', operator: 'eq', value: 'curious' }, next: 'p08-motive-curious' },
      ],
      fallback: 'p08-mentor-debrief',
    },
  },
  {
    id: 'p08-motive-serious',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '你说这次想认真冲榜，那就别只看哪个组现在排名高。选一个今晚能把你带起来、下周还愿意给你位置的。',
    background: 'nightMessage', historical: 'fictional', next: 'p08-mentor-debrief',
  },
  {
    id: 'p08-motive-together',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '本来说一起玩，结果这两天净让你自己找位置了。你选哪边都行，晚上缺人就叫我，我还能过去补一车。',
    background: 'nightMessage', historical: 'fictional', next: 'p08-mentor-debrief',
  },
  {
    id: 'p08-motive-curious',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '你之前问祈福以后走了怎么办。现在正好看看：一个组能不能玩下去，不能只看首领是谁，还得看今晚到底有没有人等你上线。',
    background: 'nightMessage', historical: 'fictional', next: 'p08-mentor-debrief',
  },
  {
    id: 'p08-mentor-debrief',
    chapter: 'prologue', actLabel: '第一章 · 谁来坐第二席', date: '2026-07-19',
    location: '老朋友', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '四边你都聊过了。别再看招募词，想想今晚八点你最愿意点进哪个队伍。',
    background: 'nightMessage', historical: 'fictional',
    choices: [
      {
        id: 'lean-toward-invite', label: '“我大概知道想和谁站一起了。”', tone: 'warm',
        effects: [
          { type: 'flag', key: 'consideredExistingOrganizations' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'p09-level-twenty',
      },
      {
        id: 'dream-sixth-seat', label: '“可我还是想自己试一次。”', tone: 'secret',
        effects: [
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'flag', key: 'dreamedSixthSeat' },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
        ],
        next: 'p09-level-twenty',
      },
    ],
  },
  {
    id: 'p09-level-twenty',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    title: '组织功能开放',
    location: '组织大厅',
    mode: 'system',
    speaker: 'system',
    text: '等级达到20。群雄逐鹿已经占住第一席；第二到第五席的创建申请同时亮起，最下面还有一个空白入口。',
    background: 'organization',
    sound: 'notice',
    historical: 'adapted',
    onEnter: [{ type: 'stat', key: 'level', operation: 'set', value: 20 }],
    next: 'p09a-mentor-push',
  },
  {
    id: 'p09a-mentor-push',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '都在等你回话了。选今晚你真愿意进的队伍。想回一组就直说，不回也别把别人的位置只当临时落脚。',
    background: 'nightMessage',
    sound: 'message',
    historical: 'fictional',
    next: 'p09b-before-choice',
  },
  {
    id: 'p09b-before-choice',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    title: '五个窗口',
    location: '组织大厅',
    mode: 'novel',
    speaker: 'narrator',
    text: '一组的申请、四条刚聊完的邀请和最下面的创建入口同时亮着。每个窗口都有人等你回一句。',
    background: 'organization',
    historical: 'fictional',
    next: 'p10-route-choice',
  },
  {
    id: 'p10-route-choice',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    title: '你按下的名字',
    location: '组织大厅',
    mode: 'novel',
    speaker: 'narrator',
    text: '今晚的活动快开始了。你最后看了一遍那些集合时间，按下确认。',
    background: 'organization',
    historical: 'fictional',
    choices: [
      {
        id: 'join-org1', label: '“我还是想回一组。榜不够，我就继续追。”', tone: 'warm',
        effects: [
          { type: 'route', route: 'org1', organization: 'org1', role: 'member' },
          { type: 'stat', key: 'cohesion', operation: 'set', value: 2 },
          { type: 'stat', key: 'contribution', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
          { type: 'relationship', character: 'bottle', key: 'trust', value: 1 },
          { type: 'flag', key: 'joinedEstablishedOrg' },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 2 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r1-00-joined',
      },
      {
        id: 'lead-org2', label: '“夏娜，我去江南。今晚八点我在。”', tone: 'warm',
        effects: [
          { type: 'route', route: 'org2', organization: 'org2' },
          { type: 'stat', key: 'money', value: -10 },
          { type: 'stat', key: 'cohesion', operation: 'set', value: 2 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'flag', key: 'foundedCanonicalOrg' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
        ],
        next: 'r2-00-founded',
      },
      {
        id: 'lead-org3', label: '“心跳，八点半那车给我留一个。”', tone: 'calm',
        effects: [
          { type: 'route', route: 'org3', organization: 'org3' },
          { type: 'stat', key: 'money', value: -10 },
          { type: 'stat', key: 'cohesion', operation: 'set', value: 2 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'heartbeat', key: 'trust', value: 1 },
          { type: 'flag', key: 'foundedCanonicalOrg' },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 2 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
        ],
        next: 'r3-00-founded',
      },
      {
        id: 'lead-org4', label: '“砚秋水，规则我看完了。我来。”', tone: 'calm',
        effects: [
          { type: 'route', route: 'org4', organization: 'org4' },
          { type: 'stat', key: 'money', value: -10 },
          { type: 'stat', key: 'cohesion', operation: 'set', value: 2 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'yanqiu', key: 'trust', value: 1 },
          { type: 'flag', key: 'foundedCanonicalOrg' },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 2 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'r4-00-founded',
      },
      {
        id: 'lead-org5', label: '“温陷，九点以后那个位置给我留着。”', tone: 'warm',
        effects: [
          { type: 'route', route: 'org5', organization: 'org5' },
          { type: 'stat', key: 'money', value: -10 },
          { type: 'stat', key: 'cohesion', operation: 'set', value: 2 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'wenxian', key: 'trust', value: 1 },
          { type: 'flag', key: 'foundedCanonicalOrg' },
          { type: 'butterflyDelta', key: 'bf_heart', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_loyalty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_diplomacy', delta: 1 },
        ],
        next: 'r5-00-founded',
      },
      {
        id: 'lead-org6', label: '“我想自己建一个。今晚先从招人开始。”', tone: 'secret',
        effects: [
          { type: 'route', route: 'org6', organization: 'org6' },
          { type: 'stat', key: 'money', value: -30 },
          { type: 'stat', key: 'cohesion', operation: 'set', value: 1 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'flag', key: 'foundedSixthOrg' },
          { type: 'butterflyDelta', key: 'bf_cruelty', delta: 1 },
          { type: 'butterflyDelta', key: 'bf_chaos', delta: 2 },
          { type: 'butterflyDelta', key: 'bf_shadow', delta: 1 },
        ],
        next: 'p10-route6-name',
      },
    ],
  },
  {
    id: 'p10-route6-name',
    chapter: 'prologue',
    actLabel: '第一章 · 谁来坐第二席',
    date: '2026-07-19',
    title: '创建第六组织',
    location: '组织创建',
    mode: 'system',
    speaker: 'system',
    text: '没有人替你准备招募词，也没有现成的成员名单。创建栏只剩最后一格：组织名。',
    background: 'organization',
    historical: 'fictional',
    presentation: { ui: 'organization' },
    textEntry: {
      key: 'sixthOrganizationName',
      label: '给第六个席位取名',
      placeholder: '第六席',
      maxLength: 10,
      submitLabel: '确认创建',
      applyTo: 'organizationName',
      next: 'r6-00-founded',
    },
  },
] satisfies StoryNode[]
